import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, sub }) => (
  <div className="mb-14 max-w-3xl">
    <Reveal y={20}>
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-emerald-700 sm:text-sm">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-ink/70 sm:text-lg">{sub}</p>
      </Reveal>
    )}
  </div>
);
